import {
  TBenefitsSavings,
  TMenhirBenefitsSavings,
  TMenhirSavingDetails,
  TMenhirSavingsFullEnvelope,
  TMenhirSavingsSimpleEnvelope,
  TSavingDetails,
  TSavingsFull,
} from '@/common/integrations/menhir/employee/savings/savings.types';
import { TMoney, defaultMoney } from '@coverflex-tech/hypernova-utils';

export const transformSavings = ({
  savings,
}: TMenhirSavingsSimpleEnvelope): TMoney => savings.total;

export const transformBenefitSavingDetails = (
  details: TMenhirSavingDetails
): TSavingDetails => ({
  socialSecurity: details.social_security
    ? {
        amount: details.social_security?.amount,
        rate: details.social_security?.rate,
      }
    : undefined,
  taxIncome: details.tax_income
    ? {
        amount: details.tax_income?.amount ?? defaultMoney,
        rate: details.tax_income?.rate,
      }
    : undefined,
  totalGross: details.total_gross,
  totalSpent: details.total_spent,
});

export const transformBenefitsSavings = (
  benefits: TMenhirBenefitsSavings[]
): TBenefitsSavings[] =>
  benefits.map((benefit) => ({
    details: transformBenefitSavingDetails(benefit.details[0]),
    slug: benefit.slug,
    totalSavings: benefit.total_savings,
  }));

export const transformSavingsDetails = ({
  savings,
}: TMenhirSavingsFullEnvelope): TSavingsFull => ({
  benefits: transformBenefitsSavings(savings.benefits),
  firstMovementDate: savings.first_movement_date,
  total: savings.total,
});
